<template>
  <div class="row">
    <div class="col-12">
      <label for="inputCostumersList">Cliente</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-user-circle fa-fw"></i>
          </span>
        </div>
        <input type="hidden" autocomplete="off" :required="required" id="costumerId" name="costumer_id" />
        <input type="hidden" autocomplete="off" id="costumerData" name="costumer_data" />
        <input type="text" autocomplete="off" class="form-control autoComplete" id="inputCostumersList"
          name="costumer_name" ref="costumers" placeholder="Digite para buscar o cliente" :required="required"
          :readonly="readonly" :disabled="disabled" />
      </div>

      <div v-if="found" id="selectCostumers" class="div_founds">
        <div class="list-group">
          <!-- list of founded costumers -->
        </div>
        <div id="loading-indicador" class="text-center" style="font-size: 16px;" hidden>
          <i class="fas fa-spinner fa-fw fa-spin"></i> Procurando cliente.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      found: [],
      selected: ""
    };
  },
  mounted: function () {
    const self = this;
    let typingTimer;
    clearTimeout(typingTimer);

    $(".autoComplete").on("input", function (event) {
      const thisInput = this
      let name = $(this).val();
      if (name.length != 0) {
        $("#loading-indicador").attr("hidden", false);

        typingTimer = setTimeout(() => {
          let url = window.location.pathname == "/dialer"
            ? "/dialer/searchClients"
            : "/customer_base/searchClients";

          axios.get(url, { params: { search: name } })
            .then(({ data }) => {
              $("#loading-indicador").attr("hidden", true);
              $("#selectCostumers div.list-group button").remove();
              self.found = [];
              if (data.length <= 0) return;
              self.found = data.map(el => {
                return {
                  nome_fantasia: el.nome_fantasia || "",
                  razao_social: el.razao_social || "",
                  cod_cliente: el.cod_cliente || "",
                  cep: el.cep || "",
                  cidade: el.cidade || "",
                  endereco: el.endereco || "",
                  loj: el.loj || "",
                  lojnome: el.lojnome || "",
                  lojresumido: el.lojresumido || "",
                  tlvresumido: el.tlvresumido || "",
                  uf: el.uf || "",
                  nome_vendedor: el.nome_vendedor || "",
                  cod_vendedor: el.cod_vendedor || "",
                  cpf_cnpj: el.cpf_cnpj || "",
                  telefone1: el.telefone1 || "",
                  telefone2: el.telefone2 || "",
                  telefone3: el.telefone3 || "",
                  telefone3: el.telefone3 || "",
                  responsibles: [{razao_social: el.razao_social || "",}]
                }
              });

              self.found.forEach(item => {
                const costumerName = item.razao_social == "" ? item.nome_fantasia : item.razao_social
                const listItem = `<button type="button" data-id="${item.cod_cliente
                  }" data-name="${costumerName}" class="list-group-item list-group-item-action costumerListItem">${costumerName}</button>`;
                $("#selectCostumers div.list-group").append(listItem);
              });

              $(document).unbind().on("click", function (event) {
                event.stopPropagation();
                if (
                  $(event.target).hasClass("costumerListItem") ||
                  event.target.id == "inputCostumersList"
                ) {
                  let elem = $(event.target);
                  let id = elem.data("id");
                  let name = elem.data("name");

                  $.each(self.found, function (index, item) {
                    if (item.cod_cliente == id) {
                      $("#inputCostumersList").val(name);
                      $("#costumerId").val(id);
                      $("#costumerData").val(JSON.stringify(item));

                      let closestForm = $(thisInput).closest('form')[0]
                      window.populate(closestForm, item);

                      $('#inputCostumersList').trigger('custom', item);

                      self.found = 0;
                    }
                  });
                }
              });
            });
          return;
        }, 1000);
      } else {
        self.found = 0;
      }
    });

    $(".autoComplete").on("keydown", function () {
      clearTimeout(typingTimer);
    });
  }
};
</script>

<style>
.div_founds {
  background-color: #ffffff;
  border-radius: 3px;
  position: absolute;
  height: auto;
  width: 92%;
  z-index: 9999;
  box-shadow: 0px 3px 3px #ccc;
}
</style>